import { defineComponent as _defineComponent } from 'vue'
import BButton from 'JS/components/BButton.vue';
import BTextField from 'JS/components/blain-form/BTextField.vue';
import bugsnagClient from 'JS/global/bugsnag';
import EmailSubscriptionService from 'JS/services/EmailSubscriptionService';
import { onMounted, onUnmounted, ref } from 'vue';
import { validateEmail } from 'JS/helpers/functions';

/// EMAIL SIGNUP CODE START


export default /*#__PURE__*/_defineComponent({
  __name: 'WrenwoodComingSoon',
  setup(__props) {

const email = ref("");
const isLoading = ref(false);
const error = ref("");
const sendSuccess = ref(false);

const emailService = new EmailSubscriptionService();

async function emailSignup() {
	error.value = "";

	if (!validateEmail(email.value)) {
		error.value = "Please enter a valid email";
		return;
	}

	isLoading.value = true;

	try {
		const result = await emailService.subscribeEmailToMarketing(email.value);

		window.blainGtmDataLayer.push({
			'emailAddress': email.value,
			'event': "wrenwood_signup",
		});

		if (!result.success) {
			error.value = "Something went wrong. Try again later.";
			console.error('Error sending email for wrenwood signup');
		} else {
			sendSuccess.value = true;
		}
	} catch (e) {
		bugsnagClient.notify(e);
	}

	isLoading.value = false;
}

// EMAIL SIGNUP CODE END


/// TIMER CODE START

const images = [
	'/assets/images/wrenwood/Wrenwood-slide1.jpg',
	'/assets/images/wrenwood/Wrenwood-slide2.jpg',
	'/assets/images/wrenwood/Wrenwood-slide3.jpg',
	'/assets/images/wrenwood/Wrenwood-slide4.jpg',
	'/assets/images/wrenwood/Wrenwood-slide5.jpg',
	'/assets/images/wrenwood/Wrenwood-slide6.jpg'
];

const imageIndex = ref(0);
let timer: ReturnType<typeof setInterval> | null = null;

function next() {
	imageIndex.value = (imageIndex.value + 1) % images.length;
}

onMounted(() => {
	timer = setInterval(next, 5000);
});

onUnmounted(() => {
	if (timer) clearInterval(timer);
});

/// TIMER CODE END

return { __sfc: true,email, isLoading, error, sendSuccess, emailService, emailSignup, images, imageIndex, timer, next, BButton, BTextField }
}

})